import { Grid } from "@mui/material";
import { FC } from "react";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { useSoftnetStore } from "../../hooks/useSoftnetStore";
import { ApiStatus } from "../../types/api/status";
import SyncIcon from '@mui/icons-material/Sync';
import { useNavigate } from "react-router-dom";
import { RoutesMap } from "../../types";

const columns = [
    { type: 'text', field: 'id', label: 'N°', align: 'center' },
    { type: 'text', field: 'description', label: 'Descripción', align: 'center' },
    { type: 'detail', field: 'detail', label: 'Acciones', align: 'center' },
];

const importsERP = [
    { id: 1, description: 'Sucursales' },
    { id: 10, description: 'Bodegas' },
    { id: 2, description: 'Areas de negocio' },
    { id: 3, description: 'Formas de pago' },
    { id: 7, description: 'Subcategorías específicas' },
    { id: 6, description: 'Subcategorías' },
    { id: 5, description: 'Categorías' },
    { id: 4, description: 'Productos' },
    { id: 8, description: 'Clientes' },
    { id: 9, description: 'Proveedores' }
];


const breadcrumbs = [
    { id: 1, label: 'Importaciones' },
    { id: 2, label: 'Importar ERP', pathname: RoutesMap.IMPORT_ERP }
]

export const ImportERP: FC = () => {

    const navigate = useNavigate()
    const { status, importWarehouse, importBusinessArea, importFormaPago, importProducts, importCategories, importSubcategories,
        importSpecificsubcategory, importCustomer, importSupplier, importBranchOffice } = useSoftnetStore()

    const onButton = async (rowSelected) => {
        let method: Promise<boolean | any>;

        switch (rowSelected.id) {
            case 1: // Sucursales
                method = importBranchOffice();
                break;

            case 10: // Bodegas
                method = importWarehouse();
                break;

            case 2: // Áreas de negocio
                method = importBusinessArea();
                break;

            case 3: // Formas de pago
                method = importFormaPago();
                break;

            case 7: // Subcategorías específicas
                method = importSpecificsubcategory();
                break;

            case 6: // Subcategorías
                method = importSubcategories();
                break;

            case 5: // Categorías
                method = importCategories();
                break;

            case 4: // Productos
                method = importProducts();
                break;

            case 8: // Clientes
                method = importCustomer();
                break;

            case 9: // Proveedores
                method = importSupplier();
                break;

            default:
                method = Promise.resolve(false);
                break;
        }

        await method;
    };

    const onDetails = (rowSelected) => {
        let url = '';

        switch (rowSelected.id) {
            case 1: // Sucursales
                url = RoutesMap.IMPORT_WAREHOUSE;
                break;

            case 10: // Bodegas
                url = RoutesMap.IMPORT_BRANCH;
                break;

            case 2: // Áreas de negocio
                url = RoutesMap.IMPORT_BUSINESS_AREA;
                break;

            case 3: // Formas de pago
                url = RoutesMap.IMPORT_WAY_TO_PAY;
                break;

            case 7: // Subcategorías específicas
                url = RoutesMap.IMPORT_SPECIFIC_SUBCATEGORY;
                break;

            case 6: // Subcategorías
                url = RoutesMap.IMPORT_SUBCATEGORY;
                break;

            case 5: // Categorías
                url = RoutesMap.IMPORT_CATEGORY;
                break;

            case 4: // Productos
                url = RoutesMap.IMPORT_PRODUCT;
                break;

            case 8: // Clientes
                url = RoutesMap.IMPORT_CUSTOMER;
                break;

            case 9: // Proveedores
                url = RoutesMap.IMPORT_SUPPLIER;
                break;

            default:
                break;
        }

        if (url) navigate({ pathname: url });
    };

    return (
        <Grid item xs={12}>
            <CustomTable
                breadcrumbs={breadcrumbs}
                title={'Importar del ERP Softnet'}
                columns={columns}
                rows={importsERP || []}
                loading={status === ApiStatus.FETCHING}
                onRowClick={() => { }}
                hasOptions
                onDetails={onDetails}
                onHelper={onButton}
                tooltip_helper={'Sincronizar'}
                icon_helper={<SyncIcon fontSize="small" />}
                dense
                withoutPagination
            />
        </Grid>
    )
}